import UserService from "@/services/UserService";
import SurveyService from "@/services/SurveyService";
import CountryService from "@/services/CountryService";

export default {
  users: {
    list: [],
    loader: UserService.list,
    touched: false,
    clearRoute: "setting-users",
  },
  getLaunchYears: {
    list: [],
    loader: SurveyService.getLaunchYears,
    touched: false,
  },
  getProgramType: {
    list: [],
    loader: SurveyService.getProgramType,
    touched: false,
  },
  getProgramMajorInUse: {
    list: [],
    loader: SurveyService.getProgramMajorInUse,
    touched: false,
  },
  getCountries: {
    list: [],
    loader: SurveyService.getCountries,
    touched: false,
  },
};
